import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDbinsDeployedIn.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return /^(PHYS|VR)$/.test(type)
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'PHYS_'},
                {type: 'VR_'},
            ]
        },

        async _atPush(map, node, event) {
            event.stopPropagation()

            const next = chain => {
                const _n = map.nodeProxy(chain[0])
                return {yieldChildren: _n.isMounted()}
            }

            for (const n of map.bfs(node.children, next)) {
                const {bizNodeType, prjId, psCode, rev, sVer, vsCode} = n.data

                if ('PHYS' === bizNodeType) {
                    event.detail.archDbInsDeploys.push({
                        deployCode: psCode,
                        deployPrjId: prjId,
                        deploySVer: sVer,
                        deployType: 'PS',
                        deployVer: rev,
                    })
                }
                if ('VR' === bizNodeType) {
                    event.detail.archDbInsDeploys.push({
                        deployCode: vsCode,
                        deployPrjId: prjId,
                        deploySVer: sVer,
                        deployType: 'VS',
                        deployVer: rev,
                    })
                }
            }
        },
    })
}
